export default __webpack_public_path__ + "static/media/crude-protein-cion.a55d7af4.svg";